import scrollToElement from '../../utils/scroll-to-element';

export const setupFindAgent = () => {
  const findAgent = document.querySelector('[data-find-an-agent]');
  if (findAgent && window.location.href.includes('SearchAgent')) {
    setTimeout(() => {
      scrollToElement(findAgent as HTMLElement);
    }, 500);
  }
};
